import type { ProjectState } from "@livcg/schema";
import { VarControls } from "../VarControls.js";
import { Panel } from "./Panel.js";

export function VarPanel({ slug, state }: { slug: string; state: ProjectState }) {
  return (
    <Panel label="VAR">
      <VarControls slug={slug} state={state} />
    </Panel>
  );
}
